import { cn } from '~/lib/utils'
import Image from '~/components/Helpers/Image'

export type LogoProps = {
  content: {
    eyebrow?: string
    alignment?: string
    logos: {
      image: Image
      link?: string
    }[]
    stacked?: boolean
  }
  layoutColour?: string
  className?: string
}

const Logos = ({ content, layoutColour, className }: LogoProps) => {
  const { logos, eyebrow, alignment, stacked } = content

  // console.log(stacked)

  return (
    <>
      {eyebrow && (
        <p
          className={cn(
            'tag mb-m',
            alignment === 'centred' ? 'text-center' : ''
          )}
        >
          {eyebrow}
        </p>
      )}
      <div className='@container/logoblock mx-auto w-full max-w-[1380px] overflow-hidden'>
        <div
          // className={cn(
          //   // 'divide-blue-d gap-s mx-auto flex flex-wrap justify-center',
          //   'gap-s flex w-full flex-wrap items-center',
          //   ['ink-blue', 'mid-blue'].includes(layoutColour ?? '')
          //     ? 'divide-white/40'
          //     : 'divide-blue-d-40',
          //   stacked ? 'sm:divide-y md:flex-col' : 'sm:gap-x-l space-y-s',
          //   alignment === 'centred' ? 'justify-center' : '',
          //   className
          // )}
          className={cn(
            'gap-y-s -ml-xs flex w-full flex-wrap justify-center',
            ['ink-blue', 'mid-blue'].includes(layoutColour ?? '')
              ? 'divide-white/40'
              : 'divide-blue-d-40',
            stacked
              ? 'divide-y md:flex-col'
              : 'max-sm:-mb-[1px] max-sm:divide-y @max-[37.5rem]/logoblock:-mb-[1px] @max-[37.5rem]/logoblock:divide-y',
            alignment === 'centred' ? 'justify-center' : '',
            className
          )}
        >
          {logos?.map((logo, index: Index) => (
            <a
              href={logo?.link}
              key={index}
              className={cn(
                'unstyled-link mx-s mr-0 flex min-w-[150px] grow basis-1/2 items-center justify-between',
                'max-sm:pb-s @max-[37.5rem]/logoblock:pb-s max-sm:last:mb-[1px] @max-[37.5rem]/logoblock:last:mb-[1px]',
                // '[&:nth-last-child(2)]:pb-0 max-sm:[&:nth-last-child(2)]:border-0 max-sm:[&:nth-last-child(2)]:pb-0 [&:nth-last-child(2)]:border-0',
                'not-last:after:bg-blue-d-40 not-last:after:-mr-s not-last:after:h-full not-last:after:w-[1px] max-sm:after:hidden @max-[37.5rem]/logoblock:after:hidden',
                stacked
                  ? 'not-last:pb-s max-h-[120px] min-h-[120px] max-w-[320px] basis-full lg:max-w-[380px]'
                  : 'max-w-[200px] sm:basis-1/4 lg:max-w-[250px] lg:basis-1/6 @max-[86.2rem]/logoblock:max-w-[200px]'
              )}
              // className={cn(
              //   'unstyled-link flex h-full w-full max-w-[150px] min-w-[150px] basis-1/2 items-center',
              //   stacked
              //     ? 'not-last:pb-s sm:max-w-[320px] sm:basis-full lg:max-w-[380px]'
              //     : 'sm:basis-1/4 lg:max-w-[200px] lg:basis-1/6'
              // )}
              target='_blank'
              rel='noreferrer'
            >
              <Image
                image={logo.image}
                // classes={cn(
                //   'h-full w-full object-contain',
                //   stacked ? 'max-h-[200px]' : 'max-h-[100px]'
                // )}
                containerClasses='flex grow justify-center'
                classes={cn(
                  'w-full h-full object-contain min-w-[150px]',
                  stacked
                    ? 'max-h-[90px] max-w-[320px] lg:max-w-[380px]'
                    : 'sm:max-h-[100px] max-h-[75px] @max-[86.2rem]/logoblock:max-w-[150px] lg:max-w-[200px] max-w-[150px]'
                )}
              />
            </a>
          ))}
        </div>
      </div>
    </>
  )
}

export default Logos
